import { gameArea } from "../utils/gameArea";
import GameScene from "../scenes/GameScene";

export default abstract class BaseCombatant extends Phaser.Physics.Arcade.Sprite {
    speed: number;
    maxHealth: number;
    health: number;
    shadow: Phaser.GameObjects.Sprite;
    directionFacing: Phaser.Math.Vector2;
    prevDirection: Phaser.Math.Vector2;

    constructor(scene: GameScene, x: number,y: number,name: string){
        const shadow = scene.add.sprite(x,y,"playerShadow");
        super(scene,x,y,name);
        scene.add.existing(this);
        scene.physics.add.existing(this);
        this.body.enable = true;
        this.body.setCircle(4);
        this.body.setOffset(12,13);
        this.body.setMass(2);

        this.name = name;

        this.setBounce(0.1); // our player will bounce from items
        this.setCollideWorldBounds(true); // don't go out of the map
        this.setScale(gameArea.scale);

        this.speed = 150;

        this.maxHealth = 100;
        this.health = 10;

        this.shadow = shadow;
        scene.add.existing(this.shadow);
        this.shadow.setScale(gameArea.scale);
        this.shadow.setOrigin(0.55,0.25);
        this.shadow.setAlpha(0.75);


        this.directionFacing = new Phaser.Math.Vector2(1,1);
        this.prevDirection = new Phaser.Math.Vector2(0,0);

    }

    stop(){
        this.prevDirection.set(0,0);
        this.setAcceleration(0,0);
        this.setVelocity(0,0);
    }

    preUpdate(time: number, delta: number){
        this.shadow.setPosition(this.x, this.y);
        this.anims.update(time,delta);
    }

    reset(){
        this.setDepth(3);
        this.health = this.maxHealth;
    }

    isAttacking(){
        return false;
    }

    canBeHit(){
        return false;
    }

    takeHit(direction: Phaser.Math.Vector2, damage: number){

    }

    destroy(){
        this.shadow.destroy(true);
        super.destroy();
    }
    
}